import ProductForm from "./product-form"
const InitProductForms = (selector = '[sh-product-form]') => {
  const forms = document.querySelectorAll(selector);

  if (typeof (forms) !== 'undefined' && forms.length > 0) {
    forms.forEach(form => {
      const data = form.dataset;
      if (typeof (data.productId) != 'undefined') {
        let productData = form.querySelector('.product-json');
        try {
          productData = JSON.parse(productData.textContent);
          let product = new ProductForm(productData, form);
          product.init();
        } catch ($e) {
          // handle the error to console
          console.log('error', $e);
        }
      }
    });
  }

}

export default InitProductForms
